// removed by extract-text-webpack-plugin
module.exports = {"Header":"_1_1R8koVt7","toggler":"_27Grkxrlgk"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Header/Header.scss
// module id = 896
// module chunks = 0